var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hococo-admin-conversation"},[((_vm.messageDataLoaded && _vm.conversationList.length > 0 && _vm.activeConversation))?_c('Feed',{attrs:{"conversation":_vm.activeConversation}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }